import { useModal } from "../_providers/ModalProvider";

export const ConfirmationModal = (props: {message: string, onConfirm: () => void}) => {
    const modelContext = useModal();
    return (
        <div>
            <p>{props.message}</p>
            <div style={{display: "flex", gap: "10px"}}>
                <button className="btn cancel-btn" onClick={() => modelContext.closeModal()}><p>Cancel</p><i style={{fontSize: 16}} className="fa-solid fa-times" /></button>
                <button className="btn warning-btn" onClick={props.onConfirm}><p>Remove</p> <i className="fa-solid fa-trash" /></button>
            </div>
        </div>
    )
}